"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
__exportStar(require("./dictionary/loader/deserializer"), exports);
__exportStar(require("./dictionary/parameter/normal-parameter"), exports);
__exportStar(require("./dictionary/parameter/parameter"), exports);
__exportStar(require("./dictionary/saver/file-name-resolver"), exports);
__exportStar(require("./dictionary/saver/serializer"), exports);
__exportStar(require("./dictionary/dictionary"), exports);
__exportStar(require("./dictionary/dictionary-settings"), exports);
__exportStar(require("./dictionary/equivalent"), exports);
__exportStar(require("./dictionary/information"), exports);
__exportStar(require("./dictionary/marker"), exports);
__exportStar(require("./dictionary/parsed-word"), exports);
__exportStar(require("./dictionary/parser"), exports);
__exportStar(require("./dictionary/part"), exports);
__exportStar(require("./dictionary/relation"), exports);
__exportStar(require("./dictionary/revision"), exports);
__exportStar(require("./dictionary/section"), exports);
__exportStar(require("./dictionary/search-result"), exports);
__exportStar(require("./dictionary/suggestion"), exports);
__exportStar(require("./dictionary/word"), exports);
exports.VERSION = "0.8.1";
